import { useRecoilCallback } from 'recoil';
import { imagePopupState } from '../store/state';

export const useOpenPopup = () => {
  return useRecoilCallback(
    ({ set }) => (
      namespace: ImageV3State.PopupType,
      target: number,
      type?: number
    ) => {
      set(imagePopupState(namespace), {
        visible: true,
        target,
        type: type || 0
      });
    },
    []
  );
};
